module.exports = function getResource(label, vars = []) {
    let resources = {
        canadaLegalCopy: 'Sephora Beauty Canada, Inc. (600 Boulevard de Maisonneuve Ouest, Suite 2400, Montréal, Québec, H3A 3J2, sephora.ca) demande le consentement en son propre nom et au nom de Sephora USA, Inc. (525, Market Street, Floor 32, San Francisco, CA 94105, sephora.com). Vous pouvez retirer votre consentement en tout temps.',
        prop65Msg: 'L’expédition de cet article est interdite vers les adresses californiennes.',
        comingSoon: 'À venir',
        availableInStoreOnly: 'Uniquement disponible en magasin',
        soldOut: 'Rupture de stock',
        outOfStock: 'Rupture de stock',
        emailWhenInStock: 'M’envoyer un courriel lorsque le produit est en stock',
        removeReminder: 'Annuler le rappel'
    };

    return resources[label];
};
